import { useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';
import { Flex, useSafeArea } from '@banhala/ui-kit';
import { ScrollToTopButton } from 'shared/src/component';

const EDGE_GAP = 16;

interface FolderDetailScrollTopButtonProps {
  visible: boolean;
  bottomOffset?: number;
  onPress: () => void;
}

export const FolderDetailScrollTopButton = ({
  visible,
  bottomOffset,
  onPress,
}: FolderDetailScrollTopButtonProps) => {
  const { bottom: safeAreaBottom } = useSafeArea();
  const resolvedBottom = EDGE_GAP + (bottomOffset ?? safeAreaBottom);

  const progress = useRef(new Animated.Value(visible ? 1 : 0)).current;
  useEffect(() => {
    Animated.timing(progress, {
      toValue: visible ? 1 : 0,
      duration: 200,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: true,
    }).start();
  }, [visible, progress]);

  const translateY = progress.interpolate({
    inputRange: [0, 1],
    outputRange: [resolvedBottom + 64, 0],
  });

  return (
    <Flex
      position={'absolute'}
      right={EDGE_GAP}
      bottom={resolvedBottom}
      zIndex={1}
    >
      <Animated.View style={{ opacity: progress, transform: [{ translateY }] }}>
        <ScrollToTopButton testID={'folder-detail-scroll-to-top'} onPress={onPress} />
      </Animated.View>
    </Flex>
  );
};
